import * as Mutations from './mutations';

export const MobileModule = {
    state: {
        isMobile: false,
        mobileMenu: false
    },

    mutations: {
        [Mutations.SET_IS_MOBILE] (state, isMobile) {
            state.isMobile = isMobile;
        },

        [Mutations.TOGGLE_MOBILE_MENU](state, isMobileMenu) {
            state.mobileMenu = isMobileMenu;
        }
    },

    actions: {
        openMobileMenu: async ({ commit }) => {
            window.Beacon('close');
            document.body.classList.add('stop-scrolling');
            commit(Mutations.TOGGLE_MOBILE_MENU, true);
        },

        closeMobileMenu: async ({ commit }) => {
            commit(Mutations.TOGGLE_MOBILE_MENU, false);
            document.body.classList.remove('stop-scrolling');
        }
    },

    getters: {
        isMobile: state => state.isMobile,
        mobileMenu: state => state.mobileMenu
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/mobile/mobile.module.js